__turbopack_context__.v({
  "otherActionsContainer": "RecordsListHeader-module-scss-module__z_v8xq__otherActionsContainer",
  "primary": "RecordsListHeader-module-scss-module__z_v8xq__primary",
  "recordsListHeader": "RecordsListHeader-module-scss-module__z_v8xq__recordsListHeader",
  "recordsListHeaderWrapper": "RecordsListHeader-module-scss-module__z_v8xq__recordsListHeaderWrapper",
  "searchContainer": "RecordsListHeader-module-scss-module__z_v8xq__searchContainer",
  "searchTopWrapper": "RecordsListHeader-module-scss-module__z_v8xq__searchTopWrapper",
});
